import { render, staticRenderFns } from "./SiteHeader.vue?vue&type=template&id=c502f0bc"
var script = {}
import style0 from "./SiteHeader.vue?vue&type=style&index=0&id=c502f0bc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports